var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMagnifyingGlass = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25.24 25.811"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-.028 -.028)",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 224325"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 11,
  transform: "translate(.778 .778)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m19.807 20.39 4.4 4.389"
}))));
export default SvgMagnifyingGlass;